import { useEffect } from "react";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import gsap from "gsap";
import { gtagEvent } from "../layout";

gsap.registerPlugin(ScrollTrigger);

export const useSectionViewGtagEvent = (ref, sectionName, viewStart) => {
  useEffect(() => {
    if (!ref?.current || !sectionName) return;

    const currentPage = window.location.pathname;

    const scrollTrigger = ScrollTrigger.create({
      trigger: ref.current,
      start: viewStart,
      onEnter: () => {
        gtagEvent(`viewed_${sectionName}_on_${currentPage}`, {
          category: "scroll",
          label: `viewed_${sectionName}_on_${currentPage}`,
          page: currentPage,
        });
      },
    });

    return () => scrollTrigger.kill();
  }, [ref, sectionName, viewStart]);
};
